'use client';

import { c as _c } from "react/compiler-runtime";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { ConciergeEnquiryForm } from './ConciergeEnquiryForm';
interface ConciergeEnquiryDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** Called after a successful submission (e.g. to show confirmation elsewhere). */
  onSuccess?: () => void;
  /** Passed through to the form; defaults to true (session-backed submit). */
  requireSession?: boolean;
}

/**
 * Dialog that lets a signed-in user ask for ideas or expert help. Wraps the
 * shared {@link ConciergeEnquiryForm}. On success it closes and defers the
 * confirmation to {@link onSuccess} so the parent can show it inline.
 */
export function ConciergeEnquiryDialog(t0) {
  const $ = _c(11);
  const {
    open,
    onOpenChange,
    onSuccess,
    requireSession
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <DialogHeader><DialogTitle>Get a free tailored analysis and suggestions</DialogTitle><DialogDescription>Tell me a bit about your business and what you're trying to achieve. I'll take a proper look and come back with a tailored analysis, practical suggestions, and an intro to the right expert if you need one.</DialogDescription></DialogHeader>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== onOpenChange || $[2] !== onSuccess) {
    t2 = () => {
      onOpenChange(false);
      onSuccess?.();
    };
    $[1] = onOpenChange;
    $[2] = onSuccess;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== requireSession || $[5] !== t2) {
    t3 = <DialogContent className="max-h-[90vh] overflow-y-auto sm:max-w-lg">{t1}<ConciergeEnquiryForm showInlineSuccess={false} requireSession={requireSession} onSuccess={t2} /></DialogContent>;
    $[4] = requireSession;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== onOpenChange || $[8] !== open || $[9] !== t3) {
    t4 = <Dialog open={open} onOpenChange={onOpenChange}>{t3}</Dialog>;
    $[7] = onOpenChange;
    $[8] = open;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}